import script from "./SharedMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./SharedMessage.vue?vue&type=script&setup=true&lang=js"

import "./SharedMessage.vue?vue&type=style&index=0&id=6c57a4c2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c57a4c2"]])

export default __exports__